import Vue from "vue";
import App from "./App.vue";
import "@/styles/index.scss"; // 全局样式
// import ElementUI from 'element-ui';
import VantComponents from '@/utils/vantImport';
import ElementComponents from '@/utils/elementuiImport';
import "element-ui/lib/theme-chalk/index.css";
import 'vant/lib/index.css';
// import { Lazyload } from "vant";

import VConsole from "vconsole";
import store from "./store";
import router from "./router";
// import Vant from 'vant';

import topBar from "@/components/topbar/index.vue";
import loading from "@/components/loading/index.vue";
Vue.component("topBar", topBar);
Vue.component("loading", loading);
Vue.use(VantComponents);
// Vue.use(Lazyload);
Vue.use(ElementComponents);

Vue.config.productionTip = false;
new VConsole();
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
